<div class="">
  <div class="row">
    <div class="col-sm-12">
      <!-- Date Filter Button -->
      <button
        class="btn fa fa-search m-2"
        style="background: #6e7dd2; color: #fff"
        (click)="filterToggle = !filterToggle"
      >
        <span>&nbsp;Date Filter</span>
      </button>
  
      <!-- Download CSV Button -->
      <button
        class="btn pull-right m-2"
        style="background: #6e7dd2; color: #fff"
        (click)="exportAsExcel()"
      >
        Download CSV
      </button>
  
      <!-- Bulk POD Download Button -->
      <button
        class="btn pull-right m-2"
        style="background: #6e7dd2; color: #fff"
        (click)="downloadMergedPDF()"
      >
        Bulk POD Download
      </button>
  
      <!-- Progress Bar (Loader below Bulk POD Download) -->
      <div *ngIf="isDownloading" class="progress-wrapper">
        <div class="progress-container">
          <div class="progress-bar" [style.width.%]="progress"></div>
          <p>{{ progress }}% downloaded...</p>
        </div>
      </div>


      <button class="btn pull-right m-2" style="background: #6e7dd2; color: #fff" (click)="downloadZipPODs()">
      Bulk PODs in Zip
      </button>

      <div *ngIf="ifDownloading" class="progress-container2">
        <p>Downloading files... {{ progress }}%</p>
        <div class="progress-bar2">
          <div class="progress-fill" [style.width.%]="progress"></div>
        </div>
      </div>
      
    </div>
  </div>
    
  <mat-card
    class="filter col-lg-9 px-0 py-1"
    style="margin-top: 10px"
    *ngIf="filterToggle"
  >
    <mat-card-content>
      <div class="row">
        <div class="col-sm-12">
          <button type="button" mat-raised-button class="m-1 date-filter-btn" 
              [ngClass]="{'selected': selectedDateFilter === 'Today'}"
              (click)="dateFilterChanged('Today')">
              Today
          </button>
          <button type="button" mat-raised-button class="m-1 date-filter-btn" 
              [ngClass]="{'selected': selectedDateFilter === 'Last7Days'}"
              (click)="dateFilterChanged('Last7Days')">
              Last 7 days
          </button>
          <button type="button" mat-raised-button class="m-1 date-filter-btn" 
              [ngClass]="{'selected': selectedDateFilter === 'MTD'}"
              (click)="dateFilterChanged('MTD')">
              MTD
          </button>
          <button type="button" mat-raised-button class="m-1 date-filter-btn" 
              [ngClass]="{'selected': selectedDateFilter === 'YTD'}"
              (click)="dateFilterChanged('YTD')">
              YTD
          </button>
          <button type="button" mat-raised-button class="m-1 date-filter-btn" 
              [ngClass]="{'selected': selectedDateFilter === 'CustomDate'}"
              (click)="CustomDate = !CustomDate">
              Custom Date
          </button>
      </div>
      
      </div>
      <div class="row col-sm-12 m-2 mb-3" *ngIf="CustomDate">
        <div class="col-lg-5 m-0 p-0">
          <div class="col-sm-2 newMarginClass">From:</div>
          <div class="col-sm-8">
            <div class="input-icon right" mat-menu-item>
              <input
                class="form-control"
                placeholder="Select Date"
                class="form-control"
                id="db"
                [(ngModel)]="fromDate"
                (keydown)="inputNotAllowed()"
                [owlDateTimeTrigger]="dt1"
                [owlDateTime]="dt1"
                name="dt1"
                required
              />
              <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
            </div>
          </div>
        </div>
        <div class="col-lg-5 m-0 p-0">
          <div class="col-sm-2 newMarginClass">To:</div>
          <div class="col-sm-8">
            <div class="input-icon right" mat-menu-item>
              <input
                class="form-control"
                placeholder="Select Date"
                class="form-control"
                id="db"
                [(ngModel)]="toDate"
                (keydown)="inputNotAllowed()"
                [owlDateTimeTrigger]="dt2"
                [owlDateTime]="dt2"
                name="dt2"
                required
              />
              <owl-date-time [pickerType]="'calendar'" #dt2></owl-date-time>
            </div>
          </div>
        </div>
        <div class="col-lg-1 p-0 m-0">
          <button
            type="button"
            class="add-hover btn btn-success pull-right mr-2 fa fa-search"
            style="background: #6e7dd2; color: #fff"
            (click)="dateFilterChanged('Dates')"
          >
            Search
          </button>
        </div>
        <div class="col-lg-1 p-0 m-0">
          <button
            type="button"
            class="btn filter-hover fa fa-eraser"
            style="background-color: #37474f; color: #fff !important"
            (click)="datefilterclear()"
          >
            Clear
          </button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
  
  <!-- <div class="col-sm-12 pl-0 mt-3">
    <mat-card class="filter">
      <mat-card-content>
        <form [formGroup]="filterForm">
          <div class="col-sm-12">
            <div class="row m-1">
              <div class="col-sm-4">
                <div class="col-sm-4 newMarginClass">Booking Id:</div>
                <div class="col-sm-8">
                  <input
                    class="form-control"
                    formControlName="bookingfilt"
                    type="text"
                    placeholder="Search by Booking Id"
                  />
                </div>
              </div>

              <div class="col-sm-4">
                <div class="col-sm-4 newMarginClass">XPCN No.:</div>
                <div class="col-sm-8">
                  <input
                    class="form-control"
                    formControlName="xpcnfilt"
                    type="text"
                    placeholder="Search by OrderId"
                  />
                </div>
              </div>

              <div class="col-sm-4">
                <div class="col-sm-4 newMarginClass">PO LR:</div>
                <div class="col-sm-8">
                  <input
                    class="form-control"
                    formControlName="polrfilt"
                    type="text"
                    placeholder="Search by XPTS No"
                  />
                </div>
              </div>
            </div>

            <div class="row m-1">
              <div class="col-sm-4">
                <div class="col-sm-4 newMarginClass">Customer Name:</div>
                <div class="col-sm-8">
                  <input
                    class="form-control"
                    formControlName="customerfilt"
                    type="text"
                    placeholder="Search By Any"
                  />
                </div>
              </div>
              <div class="col-sm-4">
                <div class="col-sm-4 newMarginClass">Any:</div>
                <div class="col-sm-8">
                  <input
                    class="form-control"
                    formControlName="Keyword"
                    type="text"
                    placeholder="Search By Delivered From"
                  />
                </div>
              </div>
              <div class="col-sm-12 mt-2 text-right pull-right">
                <button
                  type="button "
                  class="btn filter-hover pull-right"
                  (click)="clear()"
                  style="
                    background-color: #37474f;
                    color: #fff !important;
                    margin-left: 10px;
                  "
                >
                  Clear
                </button>
                <button
                  type="button "
                  class="add-hover btn btn-success pull-right"
                  (click)="filter()"
                  style="border: none"
                >
                  Search
                </button>
              </div>
            </div>
           
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div> -->



  
  <!-- <div class="card card-body mt-2">
    <div class="row mt-2">
        <div class="col">
            <div widget class="card border-0 box-shadow">
                <div class="card-body widget-body">
                    <form [formGroup]="filterForm">
                        <div class="row form-inline">

                            <div class="form-group col-xl-2 col-sm-6 col-12" style="color: black;">
                                <label for="filterType">Filter By:</label>
                                <select formControlName="filterType" class="form-control" style="width: 100%; border: 1px solid black;">
                                    <option value="bookingId">Booking Id</option>
                                    <option value="customerName">Customer Name</option>
                                    <option value="xpcnNo">XPCN No.</option>
                                    <option value="any">Any</option>
                                    <option value="poLr">PO LR</option>
                                </select>
                            </div>

                            <div class="form-group col-sm-3">
                                <label for="filterValue" style="color: black;">Enter Value:</label>
                                <input type="text" formControlName="filterValue" class="form-control" 
                                    placeholder="Enter search value" style="width: 100%; border: 1px solid black;">
                            </div>

                            <div class="form-group col-sm-3">
                                <button type="submit" class="btn" style="background: #6e7dd2; color: #fff;" (click)="search()">
                                    <i class="fa fa-search"></i> Search
                                </button>
                                <button type="button" class="btn" style="margin-left: 10px; background-color: #37474f; color: #fff;" (click)="clear()">
                                    <i class="fa fa-eraser"></i> Clear
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div> -->

<form [formGroup]="filterForm">
  <div class="card card-body mt-2">
    <div class="row mt-2">
      <div class="col">
        <div class="card border-0 box-shadow">
          <div class="card-body widget-body">
            <div class="row align-items-center">

              <!-- Filter By -->
              <div class="form-group col-xl-1 col-sm-6 col-12" style="color: black;">Filter By:</div>
              <div class="form-group col-xl-2 col-sm-6 col-12">
                <mat-select 
                  placeholder="Filter by" 
                  class="form-control" 
                  style="width: 100%; border: 1px solid black;"
                  [(ngModel)]="filterBy" 
                  formControlName="filterBy">
                  <mat-option value="">Select</mat-option>
                  <mat-option value="any">Any</mat-option>
                  <mat-option value="bookingId">Booking Id</mat-option>
                  <mat-option value="customer">Customer Name</mat-option>
                  <mat-option value="consignor">Consignor Name</mat-option>
                  <mat-option value="xpcn">XPCN No</mat-option>
                  <mat-option value="poLr">PO LR</mat-option>
                </mat-select>
              </div>

              <!-- Keyword -->
              <div class="form-group col-xl-4 col-sm-6 col-12">
                <label for="keyword" class="fw-bold" style="color: black;">Keyword:</label>
                <input 
                  id="keyword" 
                  type="text" 
                  class="form-control" 
                  style="border: 1px solid black;"
                  placeholder="Search by Keyword"
                  [(ngModel)]="keyword"
                  formControlName="Keyword">
              </div>

              <!-- Buttons -->
              <div class="form-group col-xl-3 col-sm-6 col-12">
                <button 
                  type="button" 
                  class="btn fa fa-search"
                  style="background-color:#6e7dd2; color:#fff;"
                  (click)="filter()">
                  <span> Search</span>
                </button>
                <button 
                  type="button" 
                  class="btn fa fa-eraser"
                  style="margin-left: 10px; background-color:#37474f; color:#fff;"
                  (click)="clear()">
                  <span> Clear</span>
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

  <div class="col-sm-12 mt-2 p-0 ml-0 mr-0">
    <div class="table table-responsive">
      <table id="example3 " class="table table-bordered p-0 m-0" matSort>
        <thead class="tbl-head m-0 p-0">
          <tr class="tr-grid-header m-0 p-0" style="background: #6e7dd2">
            <th style="min-width: 60px; color: white" scope="col">S No.</th>
            <th scope="col" style="min-width: 150px; color: white">
              Booking Date
            </th>
            <th style="color: white" scope="col">Customer Doc/LR/PO</th>
            <th style="min-width: 150px; color: white" scope="col">
              XP Booking Id
            </th>
            <th scope="col" style="min-width: 190px; color: white">
              Customer Name
            </th>
            <th style="color: white" scope="col">Consignor Name</th>
            <th style="color: white; min-width: 190px" scope="col">
              Customer Pick-up Location
            </th>
            <th style="color: white" scope="col">XPCN No</th>
            <th scope="col" style="min-width: 150px; color: white">
              XPCN Generation Date
            </th>
            <th style="color: white" scope="col">No of Packages</th>
            <th style="color: white; min-width: 160px" scope="col">
              Consignee Name
            </th>
            <th style="color: white" scope="col">Consignee Location</th>

            <th scope="col" style="min-width: 150px; color: white">
              Picked Date
            </th>
            <th scope="col" style="min-width: 150px; color: white">
              Delivered Date
            </th>
            <th style="color: white" scope="col">Delivery Days</th>
            <th scope="col" style="min-width: 150px; color: white">View POD</th>
            <th scope="col" style="min-width: 150px; color: white">Remarks</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of fullOrderList; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ item.BookingDate | date : "dd-MM-y" }}</td>
            <td>{{ item.loding_doc }}</td>
            <td>{{ item.BookingIdCode }}</td>
            <td>{{ item.Customer }}</td>
            <td>{{ item.consignor }}</td>
            <td>{{ item.PickUpAddress }}</td>
            <!-- <td class="inner-screen"> <a class="link" (click)="openLCLXPCNPreview(item.XPCNId)">{{item.XPCNNo}}</a></td> -->
            <td>
              <a class="link" (click)="openLCLXPCNPreview(item.XPCNId)">{{
                item.XPCNCode
              }}</a>
            </td>
            <td>{{ item.XPCNDate | date : "dd-MM-y" }}</td>
            <td>{{ item.boxescount }}</td>
            <td>{{ item.consignee }}</td>
            <td>{{ item.consignee_location }}</td>
            <td>{{ item.PickedDate | date : "dd-MM-y" }}</td>
            <td>{{ item.DeliveryDate | date : "dd-MM-y" }}</td>
            <td>{{ item.DeliveryDays }}</td>
            <td>
              <a href="{{ item.PodDocUrl }}" target="_blank"
                ><button
                  *ngIf="item.PodDocUrl != null"
                  class="btn btn-success btn-sm"
                >
                  View POD
                </button></a
              >
              <a
                ><button
                  *ngIf="item.PodDocUrl == null"
                  disabled
                  class="btn btn-success btn-sm"
                >
                  View POD
                </button></a
              >
            </td>
            <td>{{ item.pod_remark }}</td>
          </tr>
          <tr *ngIf="fullOrderList.length == 0">
            <td class="text-center" colspan="100">No Records Found</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <mat-paginator
    [length]="totalSize"
    [pageIndex]="currentPage"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 25, 50, 100]"
    (page)="handlePage($event)"
    showFirstLastButtons
  >
  </mat-paginator>
</div>
